import { render, staticRenderFns } from "./permissionPanel.vue?vue&type=template&id=598a0f88&scoped=true&"
import script from "./permissionPanel.vue?vue&type=script&lang=js&"
export * from "./permissionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598a0f88",
  null
  
)

export default component.exports